import { useEffect, useState } from 'react';
import { FiToggleLeft, FiToggleRight } from 'react-icons/fi';
import { apiAdminGetHomeSections, apiAdminToggleHomeSection } from '../api';

const HomeSectionsManager = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState('');

  useEffect(() => {
    apiAdminGetHomeSections()
      .then(({ data }) => setSections(data || []))
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  const toggle = async (key) => {
    setUpdating(key);
    try {
      const { data } = await apiAdminToggleHomeSection(key);
      setSections((current) => current.map((section) => section.key === key ? data : section));
    } catch {
      // API client displays the error toast.
    } finally {
      setUpdating('');
    }
  };

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-bold text-black">Home Page Sections</h1>
        <p className="text-sm text-gray-600">Choose which sections are visible on the storefront home page.</p>
      </header>
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
        {loading ? <p className="p-8 text-center">Loading...</p> : sections.map((section) => (
          <div key={section.key} className="flex items-center justify-between gap-4 border-b border-gray-100 p-4 last:border-b-0">
            <div>
              <p className="font-medium text-black">{section.label}</p>
              <p className="text-xs text-gray-500">
                {section.type === 'category'
                  ? `Database category #${section.categoryId}${section.categoryActive ? '' : ' · Category disabled'}`
                  : section.key}
              </p>
            </div>
            <button
              type="button"
              onClick={() => toggle(section.key)}
              disabled={updating === section.key || section.categoryActive === false}
              className={`flex min-w-28 items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium disabled:opacity-50 ${section.isActive ? 'border-green-200 bg-green-50 text-green-700' : 'border-gray-300 bg-gray-50 text-gray-600'}`}
            >
              {section.isActive ? <FiToggleRight size={20} /> : <FiToggleLeft size={20} />}
              {section.isActive ? 'Active' : 'Inactive'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSectionsManager;
